<template>
  <div>
    <CustomModal :show="show"
                 :title="genitorSelecionado ? 'Editar Genitor' : 'Adicionar Genitor'"
                 size="xl"
                 :title-button="genitorSelecionado ? 'Editar' : 'Salvar'"
                 @closeModal="() => this.$emit('close')"
                 @ok="() => salvarDados()">
      <div class="nascimento-filiacao">
        <div class="row col">
          <CustomInput class="col-6"
                       name="nome"
                       label="Nome"
                       type="text"
                       :initial-value="form.nome"     
                       @blur="(name, value) => form.nome = value" />
          <CustomInput class="col-3"
                       name="municipio"
                       label="Municipio nascimento"
                       type="text"
                       @blur="(name, value) => form.municipio = value" />
          <CustomSelect :options="ufOptions"
                        name="uf-label"
                        class="col-2"
                        label="UF"
                        :selected="form.uf"  
                        @setSelectValue="(ev) => form.uf = ev.value" />
        </div>
        <div class="row mt-3 col-12">
          <label class="impressao--label"
                 for="avos">Avós</label>
          <textarea v-model="form.avos"
                    class="form-control form-control-sm w-100"
                    cols="30"
                    rows="4" />
        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>
  import CustomInput from '@/components/CustomInputs/CustomInput.vue'
  import CustomSelect from '@/components/CustomInputs/CustomSelect'
  import brazilianStates from '../../../../constants/brazilianStates'
  import CustomModal from '@/components/CustomModal/CustomModal'

  const DEFAULTFORM = {
    nome: '',
    municipio: '',
    uf: '',
    avos: ''
  }
  export default {
    name: 'AddGenitorModal',
    components: {
      CustomInput,
      CustomSelect,
      CustomModal
    },
    props: {
      genitorSelecionado: { type: Object || null, default: null},
      indexGenitorSeleciodado: { type: Number || null, default: 0},
      show: {type: Boolean, default: false}
    },
    data () {
      return {
        form: DEFAULTFORM,
        ufOptions: brazilianStates.map((item) => ({text: item.uf, value: item.uf})),
      }
    },
    watch: {
      genitorSelecionado: {
        handler () {
          this.init()
        },
        immediate: true
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {    
        this.form = this.genitorSelecionado ? Object.assign({}, this.genitorSelecionado) : { ...DEFAULTFORM }
      },
      salvarDados () {
        this.genitorSelecionado ? this.$emit('updateGenitor',  this.indexGenitorSeleciodado, this.form,) : this.$emit('createGenitor', this.form)
        this.form = { ...DEFAULTFORM }
      },
    },
  }
</script>

<style lang="scss">
  //@import '../../../scss/_utilities/_exports';
  .uf-label {
    padding-bottom: 0px
  }
</style>
